import React from 'react';
import { FadeIn } from './Shared';
import { Clock, HeartCrack, XCircle } from 'lucide-react';
export function Story() {
  return <section className="py-24 bg-brand-teal text-brand-cream" data-id="element-170">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-171">
        <FadeIn data-id="element-172">
          <div className="flex items-center justify-center mb-8" data-id="element-173">
            <Clock className="w-12 h-12 text-brand-gold opacity-80" data-id="element-174" />
          </div>
          <h2 className="text-3xl md:text-4xl font-heading text-center mb-12 text-brand-gold" data-id="element-175">
            Son las 11:00 PM.
          </h2>
          <div className="space-y-6 text-lg md:text-xl leading-relaxed text-brand-cream/90 font-light" data-id="element-176">
            <p data-id="element-177">
              El silencio en tu casa en Estados Unidos se siente pesado, casi
              asfixiante. Tienes el celular en la mano, peleando contra la
              urgencia compulsiva de revisar sus redes o enviarle un mensaje que
              sabes que no deberías enviar. Sientes que si no sabes de él, te
              vas a desintegrar.
            </p>
            <p data-id="element-178">
              No es falta de dignidad. No es que seas "débil". Es una respuesta
              biológica de tu cerebro adicto a la dopamina que él te
              proporcionaba. Estás en medio de una abstinencia real, y no se
              cura con "echarle ganas", se cura con un método estratégico.
            </p>
          </div>
        </FadeIn>

        <div className="mt-24" data-id="element-179">
          <FadeIn data-id="element-180">
            <div className="flex items-center justify-center mb-8" data-id="element-181">
              <HeartCrack className="w-12 h-12 text-brand-rose opacity-80" data-id="element-182" />
            </div>
            <h2 className="text-3xl md:text-4xl font-heading text-center mb-12 text-brand-gold" data-id="element-183">
              El verdadero problema
            </h2>
            <div className="space-y-6 text-lg md:text-xl leading-relaxed text-brand-cream/90 font-light" data-id="element-184">
              <p data-id="element-185">
                Has pasado años siendo la sombra de alguien más. Te mimetizaste
                con sus gustos, sus horarios y sus metas, olvidando por completo
                quién eras tú antes de "nosotros". Ahora que la relación
                terminó, te sientes pequeña, incapaz de manejar tus finanzas
                sola y aterrorizada por un futuro que no sabes cómo construir.
              </p>
              <p data-id="element-186">
                La dependencia emocional te ha convencido de que no puedes
                funcionar sin su validación. Ese vacío en el pecho no es amor
                romántico; es el pánico de un sistema que se quedó sin su fuente
                de seguridad y no sabe cómo generar su propia fuerza.
              </p>
            </div>
          </FadeIn>
        </div>

        <div className="mt-24 bg-brand-cream/5 rounded-3xl p-8 md:p-12 border border-brand-cream/10" data-id="element-187">
          <FadeIn data-id="element-188">
            <h3 className="text-2xl md:text-3xl font-heading mb-8 text-brand-gold text-center" data-id="element-189">
              Por qué lo que has intentado no funciona
            </h3>
            <ul className="space-y-6" data-id="element-190">
              {['Salir con amigas a "distraerte" solo funciona un par de horas hasta que vuelves a la soledad de tu cuarto.', 'Bloquearlo y desbloquearlo constantemente solo reinicia el ciclo de adicción de tu cerebro.', 'Esperar que "el tiempo lo cure todo" es una estrategia pasiva que te deja estancada meses o años en el mismo dolor.', 'Leer frases motivacionales en Instagram no te enseña cómo pagar tus cuentas, mejorar tu crédito o reconstruir tu logística de vida en USA.'].map((item, i) => <li key={i} className="flex items-start" data-id="element-191">
                  <XCircle className="w-6 h-6 text-brand-rose shrink-0 mt-1 mr-4" data-id="element-192" />
                  <span className="text-lg text-brand-cream/80" data-id="element-193">{item}</span>
                </li>)}
            </ul>
          </FadeIn>
        </div>
      </div>
    </section>;
}